module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "halftitle"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("BARRY HANNAH’S")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('strong', [_vm._v("AIRSHIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Exhilarating! Hannah is afraid of nothing in experience. He runs to meet life and to transform it.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DENIS DONOGHUE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Barry Hannah’s writing is raw and exhilarating, tortured, radiant, vicious, aggressive, funny and streaked with rage, pain and bright, poetic truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—THE PHILADELPHIA INQUIRER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Hannah’s stories are powerful, and powerfully original.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN GARDNER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Barry Hannah is an original, vital talent.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—THE HOUSTON CHRONICLE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“The best young writer to appear in the South since Flannery O’Connor.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LARRY MCMURTRY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e1940b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 57
// module chunks = 0